import Axios from "axios";
import {
    SET_PUR_CS_STATE_REPORT,
    UNSET_PUR_CS_STATE_REPORT,
  } from "@/store/mutation-types";
import {getPurCSStateReport} from "@/store/api";

const state = {
    getPurCSStateReport: [],
};

const getters = {
    getPurCSStateReport(state) {
        return state.getPurCSStateReport;
    },
};

const mutations = {
    [SET_PUR_CS_STATE_REPORT](state, data) {
        state.getPurCSStateReport = data;
    },
    [UNSET_PUR_CS_STATE_REPORT](state) {
        state.getPurCSStateReport = [];
    },
};

const actions = {
    getPurCSStateReport({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.get(`${getPurCSStateReport}`, { params: data })
                .then((response) => {
                    commit(SET_PUR_CS_STATE_REPORT, response.data.data );
                    resolve(response);
                })
                .catch((error) => {
                    commit(UNSET_PUR_CS_STATE_REPORT);
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

